import { useEffect } from "react";
import { useCurrentDraftStore } from "@/stores/selected-vehicle-store";
import { refreshDraftLockAction } from "@/app/lib/actions/cat/draft-lock-heartbeat";

const HEARTBEAT_MS = 5 * 60 * 1000;

export function useDraftLockHeartbeat() {
  const draftId = useCurrentDraftStore((state) => state.currentDraft?.id);

  useEffect(() => {
    if (!draftId) {
      return;
    }

    const ping = () => {
      void refreshDraftLockAction({ draftId });
    };

    ping();
    const intervalId = window.setInterval(ping, HEARTBEAT_MS);

    const handleBeforeUnload = () => {
      void refreshDraftLockAction({ draftId });
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [draftId]);
}
